import Testimonials from "./UI/Testimonials";

export default Testimonials;